module.exports = __webpack_public_path__ + "static/media/receta-10.e5e37b5f.png";